import Event = createjs.Event;

export class LanguageDataEvent extends Event {
    // this is used in BigFarm .  renaming it would mean refactor the game as well
    public static XML_LOAD_COMPLETE: string = "xml_load_complete";
    public static FONT_LOAD_COMPLETE: string = "font_load_complete";
    public static SELECT_LANGUAGE_COMPLETE: string = "selectlanguage_complete";
    public static FONT_LOAD_START: string = "font_load_start";

    public static LANGUAGE_GENERIC_ERROR:string ="soemthing_wrong_happened_while_loading_parsing_language_json";

    public selectedLanguage: string;

    constructor(type: string, selectedLanguage: string = "", bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
        this.selectedLanguage = selectedLanguage;
    }
}

